import {
  SELECTED_COMPANY_ID,
  defaultLang,
  US_LOCALE_COMPANY_IDS
} from '../../../constants';

type SupportedLocale = 'us' | 'es' | 'pt';

export const getLocaleFromLanguage = (
  language?: string | null
): SupportedLocale | null => {
  if (!language) {
    return null;
  }

  const normalized = language.toLowerCase();

  if (normalized.startsWith('en')) {
    return 'us';
  }

  if (normalized.startsWith('es')) {
    return 'es';
  }

  if (normalized.startsWith('pt')) {
    return 'pt';
  }

  return null;
};

export const getLocaleFromNavigator = (): SupportedLocale | null => {
  if (typeof navigator === 'undefined') {
    return null;
  }

  const languageCandidates: (string | undefined)[] = [
    ...(navigator.languages ?? []),
    navigator.language
  ];

  for (const candidate of languageCandidates) {
    const locale = getLocaleFromLanguage(candidate);
    if (locale) {
      return locale;
    }
  }

  return null;
};

export const getDefaultLocale: () => SupportedLocale = () => {
  const companyId = localStorage.getItem(SELECTED_COMPANY_ID);

  /**
   * For some companies, we want to display pulsar in english by default
   */
  if (companyId && US_LOCALE_COMPANY_IDS.includes(companyId)) {
    return 'us';
  }

  const browserLocale = getLocaleFromNavigator();
  if (browserLocale) {
    return browserLocale;
  }

  return defaultLang;
};
